import React, { useContext } from 'react';
import './style.scss';
import clsx from 'clsx';
import icons from '../../common/Icons';
import { Accordion as BSAccordion, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const Accordion = ({ items }) => {
  return (
    <BSAccordion className="accordion-component-list">
      {items.map((item, index) => (
        <ListItem data={item} id={index + 1} key={index} />
      ))}
    </BSAccordion>
  );
};

const ListItem = ({ data, id }) => {
  const isActive = useContext(AccordionContext) === id;
  const onClick = useAccordionToggle(id);

  return (
    <div className="ac-list-item">
      <div className="ac-list-item-front" onClick={onClick}>
        <div className={clsx('ac-li-arrow-wrapper', isActive && 'ac-li-arrow-wrapper-active')}>
          <img
            src={icons.chevronDown}
            className={clsx('ac-li-arrow', isActive && 'ac-li-arrow-active')}
          />
        </div>
        <div className="ac-list-item-title">
          <Text field={data.fields.heading} />
        </div>
      </div>
      <BSAccordion.Collapse eventKey={id}>
        <RichText field={data.fields.text} className="ac-list-item-back" />
      </BSAccordion.Collapse>
    </div>
  );
};

export default Accordion;
